import script from "./FeedHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedHeader.vue?vue&type=script&setup=true&lang=js"

import "./FeedHeader.vue?vue&type=style&index=0&id=10ff46a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ff46a4"]])

export default __exports__